<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('scope.text_759')}}</div>
    <div slot="body">
      <dialog-selected-tips :count="params.data.length" :action="$t('scope.text_760')" :name="$t('scope.text_751')" />
      <dialog-table :data="params.data" :columns="params.columns.slice(0, 3)" />
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'InvoiceVoidDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
    }
  },
  methods: {
    doVoid (data) {
      return this.params.onManager('performAction', {
        id: this.params.data[0].id,
        managerArgs: {
          action: 'revoke',
        },
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        await this.doVoid()
        this.loading = false
        this.cancelDialog()
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>
